import { Link } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { TenancySetupSettings } from '@/components/admin/TenancySetupSettings'

/**
 * TEMPORARY standalone page for the one-time tenancy adoption step. Kept out
 * of the Configure tabs on purpose: it is transitional tooling, linked only
 * from the Networks & Tenants tab, and the whole route is deleted together
 * with the backend tenancy-setup module once adoption is done everywhere.
 */
export function TenancySetupPage() {
  return (
    <div className='flex w-full flex-col gap-6 px-10 py-6'>
      <Link
        to='/configure?tab=tenants'
        className='flex w-fit items-center gap-1.5 text-sm text-muted-foreground transition-colors hover:text-foreground'
      >
        <ArrowLeft className='h-4 w-4' />
        Back to Networks &amp; Tenants
      </Link>
      <TenancySetupSettings />
    </div>
  )
}
